import { render, staticRenderFns } from "./DailyBoxCrudPage.vue?vue&type=template&id=0b5cc554"
import script from "./DailyBoxCrudPage.vue?vue&type=script&lang=js"
export * from "./DailyBoxCrudPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports